import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
  Table,
  TableCaption,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";

import Footer from "../src/components/Footer";
import Navbar from "../src/components/Navbar";
import PageBodyLayout from "../src/components/PageBodyLayout";
import PageHeader from "../src/components/PageHeader";
import { faqAccordian } from "../src/data/FaqPageData";
import { DbsControl, UrinControl } from "../src/data/PricingPageData";

export default function faq() {
  return (
    <div className="wrapper">
      <header>
        <Navbar />
      </header>
      <main className="main">
        <PageHeader title={"Q&A - spørsmål og svar"} />

        <PageBodyLayout>
          <Accordion allowToggle>
            {faqAccordian?.length > 0 &&
              faqAccordian.map((section) => (
                <AccordionItem
                  border={"none"}
                  borderBottom="1px"
                  borderBottomColor="lightBlue"
                  key={section.title}
                >
                  <Heading>
                    <AccordionButton py={4}>
                      <Box flex="1" textAlign="left">
                        {section.title}
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </Heading>
                  {section.id === "dbcontrol" ? (
                    <AccordionPanel py={4}>
                      <div
                        dangerouslySetInnerHTML={{ __html: section.ingress }}
                      />
                      <Table
                        maxW={350}
                        size="sm"
                        variant={"unstyled"}
                        bg={"gray"}
                      >
                        <TableCaption placement={"top"}>
                          DBS- kontroller
                        </TableCaption>
                        <Thead>
                          <Tr>
                            <Th>prøver</Th>
                            <Th>Pr. pakke</Th>
                            <Th>Pr. prøve</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {DbsControl?.length > 0 &&
                            DbsControl.map((row) => (
                              <Tr key={row.tests}>
                                <Td>{row.tests}</Td>
                                <Td>{`kr ${row.perPkg},- `}</Td>
                                <Td>{`kr ${row.perTest},-`}</Td>
                              </Tr>
                            ))}
                        </Tbody>
                      </Table>
                      <Table
                        maxW={350}
                        size="sm"
                        variant={"unstyled"}
                        bg={"gray"}
                      >
                        <TableCaption placement={"top"}>
                          Dopingkontroll Urin
                        </TableCaption>
                        <Thead>
                          <Tr>
                            <Th>Prøver</Th>
                            <Th>Pr. pakke</Th>
                            <Th>Pr. prøve</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {UrinControl?.length > 0 &&
                            UrinControl.map((row) => (
                              <Tr key={row.tests}>
                                <Td>{row.tests}</Td>
                                <Td>{`kr ${row.perPkg},- `}</Td>
                                <Td>{`kr ${row.perTest},-`}</Td>
                              </Tr>
                            ))}
                        </Tbody>
                      </Table>
                    </AccordionPanel>
                  ) : (
                    <AccordionPanel
                      py={4}
                      dangerouslySetInnerHTML={{ __html: section.ingress }}
                    ></AccordionPanel>
                  )}
                </AccordionItem>
              ))}
          </Accordion>
        </PageBodyLayout>
      </main>
      <Footer />
    </div>
  );
}
